import { useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { GNoValidation, ReportShowClick } from '../../../config/Validate';
import { APP_BASE_URL, degreeList, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { postAllData } from '../../../service/ProductService';
import { DEGREEDETAILSREPORT, DOWNLOAD_GNUMBERWISE_LIST, DOWNLOADDEGREEDETAILS, GNUMBERWISEDETAILSREPORT } from '../../../config/ApiConstant';
import { DegreeDetailsListColumns, GNoWiseListColumns } from '../../../appconfig/DatatableSetting';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { downloadData, exportData } from '../../../appconfig/AppHelper';
import { commonNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { InputText } from 'primereact/inputtext';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';

export const GNumberWiseReport = () => {
    document.title = 'G number wise Detail | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    const [regNo, setRegNo] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [selectedDegree, setSelectedDegree] = useState<any>(null);
    const [GNoDetailsList, setGNoDetailsList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);

    // Date Object
    let today = new Date();
    const [dates, setDates] = useState<string | Date | Date[] | any | null>([new Date(today.setDate(today.getDate() - 31)), new Date()]);

    // On Date Change
    const onDateChange = (e: any) => {
        setDates(e.value);
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>
                    <div className="input-effect-div">
                        <InputText
                            value={regNo}
                            name="RegNo"
                            autoComplete="off"
                            placeholder="Enter multiple G numbers, separated by commas (e.g., G1000,G2000,G3000)"
                            onChange={(e) => setRegNo(e.target.value)}
                            className={errors['RegNo'] && 'p-invalid'}
                            style={{ minWidth: '600px' }}
                        />
                        <span className="focus-bg"></span>
                    </div>

                    <small className="p-invalid-txt">{errors['RegNo']}</small>
                </div>

                <Button label="Show" onClick={() => getGnoDetails()} loading={showLoading} className="ml-3"></Button>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader}></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    //export CSv
    const exportCSV = async () => {
        try {
            const { errors, isError } = GNoValidation(regNo);
            setErrors(errors);
            if (!isError) {
                setExportLoader(true);
                const data = regNo.split(',');
                // Request Data
                const requestData = {
                    RegNoList: data
                };
                // Api Call
                const response = await postAllData(DOWNLOAD_GNUMBERWISE_LIST, requestData);

                if (response?.success) {
                    setExportLoader(false);

                    //CSV Download
                    const link = document.createElement('a');
                    link.href = APP_BASE_URL + '/csv/gnolist_details.csv';
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setExportLoader(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // getGnoDetailsList
    const getGnoDetails = async () => {
        try {
            const { errors, isError } = GNoValidation(regNo);
            setErrors(errors);
            if (!isError) {
                setPageLoad(false);
                setShowLoading(true);
                const data = regNo.split(',');

                // Request Data
                const requestData = {
                    RegNoList: data
                };

                const response = await postAllData(GNUMBERWISEDETAILSREPORT, requestData);

                if (response) {
                    setPageLoad(true);
                    setShowLoading(false);
                    setGNoDetailsList(response?.data);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setShowLoading(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Reports'} pageName={'G Number Wise Detail'} pageTitle={'G Number Wise Detail'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={GNoDetailsList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {GNoWiseListColumns.map((col: any, i: any) => {
                                        if (col.field === 'address') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '4rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {GNoWiseListColumns.map((col: any, i: any) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
